import { VideoComponent } from './../video/video.component';
import { ExerciseService } from '../../services/exercise.service';
import { Exercise } from './../../models/winco/exercise.model';
import { Component, Input, ViewChild } from '@angular/core';
import { EventManagerService } from 'event-manager';
import { WincoEvents } from 'src/app/enums/winco-events..enum';

/**
 * Muestra el detalle de un ejercicio
 */
@Component({
  selector: 'app-best-exercise-detail-component',
  templateUrl: './best-exercise-detail.component.html',
  styleUrls: ['./best-exercise-detail.component.scss'],
})
export class BestExerciseDetailComponent
{
  @Input() userName:string;
  @Input() time: number;
  @Input() score:number;
  @Input() params:any[];
  @Input() urlPoster:string;
  @Input() urlVideo:string;

  @ViewChild('video') video : VideoComponent;

  constructor(private eventManagerService: EventManagerService,
              public exerciseService:ExerciseService) { }

  /**
   * Detiene la reproducción del vídeo y oculta el detalle
   */
  close()
  {
    this.video.stop();
    this.eventManagerService.emitEvent(WincoEvents.HIDE_BEST_EXERCISE);
  }
}
